import { List, Map } from "immutable";
import moment from "moment";

import sortAscendingOrder from "seneca-common/utils/functions/sorting/sortAscendingOrder/";
import sortDescendingOrder from "seneca-common/utils/functions/sorting/sortDescendingOrder";

import Assignment from "../../../models/Assignment";
import { getDueDate, getStartDate } from "./assignment";

const PRIORITISE_ASSIGNMENTS_DUE = moment.duration(3, "days");

function getVisibleAndSortedAssignments(
  assignments: Map<string, Assignment>,
  now: moment.Moment
): List<Assignment> {
  const visibleAssignments = assignments
    .toList()
    .filter(assignment => now.isAfter(getStartDate(assignment)));

  const prioritiseAssignmentsDue = now
    .clone()
    .subtract(PRIORITISE_ASSIGNMENTS_DUE);

  const topAssignments = visibleAssignments
    .filter(assignment =>
      prioritiseAssignmentsDue.isSameOrBefore(getDueDate(assignment))
    )
    .sort((a1, a2) => sortAscendingOrder(getDueDate(a1), getDueDate(a2)));

  const bottomAssignments = visibleAssignments
    .filter(assignment =>
      prioritiseAssignmentsDue.isAfter(getDueDate(assignment))
    )
    .sort((a1, a2) => sortDescendingOrder(getDueDate(a1), getDueDate(a2)));

  return topAssignments.concat(bottomAssignments);
}

export { getVisibleAndSortedAssignments };
